import { render, staticRenderFns } from "./DownloadDropdown.vue?vue&type=template&id=0655f3aa&lang=pug"
import script from "./DownloadDropdown.vue?vue&type=script&lang=js"
export * from "./DownloadDropdown.vue?vue&type=script&lang=js"
import style0 from "./DownloadDropdown.vue?vue&type=style&index=0&id=0655f3aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports